import React from 'react';

import '../styles/Footer.css';
import { bool, node } from 'prop-types';

export default function Footer({ isMobile, children }) {
    return (<footer>
        <div
            className={'footer-section'}>
            {children}
        </div>
    </footer>);
}

Footer.propTypes = {
    isMobile: bool,
    children: node,
};